<div class="qr-report-viewer-host">
  <div [id]="uniqueContainerId" class="qr-sti-viewer-container" [class.previewMode]="!windowMode"></div>
</div>
